import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { WeaponLinking } from '../models/weaponLinking';
import { DataDisplayerBase } from '../data-displayer-base';

@Component({
  selector: 'app-weapons-display',
  templateUrl: './weapons-display.component.html',
  styleUrls: ['./weapons-display.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WeaponsDisplayComponent extends DataDisplayerBase<WeaponLinking> {

}
